import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import { useInstallation, useIsotopos } from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const IsotoposInstalacionForm = () => {
  const { getValues } = useFormContext();
  const { installationList } = useInstallation();
  const { isotoposList } = useIsotopos();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("instalacion"))}
          name="instalacion"
          options={installationList}
          label="Instalación"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "La instalación es requerida" }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("isotopo"))}
          name="isotopo"
          options={isotoposList}
          label="Isotopo"
          getOptionLabel={(option) => `${option.codigo}`}
          validation={{ required: "El código es requerido" }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default IsotoposInstalacionForm;
